import {useForm} from "react-hook-form";
import React, {useContext, useEffect, useState} from "react";
import {Paper} from "@mui/material";
import strings from "../../../localization";
import DrawerContext from "../../../Context/DrawerContext";
import TablePageContext from "../../../Context/TablePageContext";
import LinearProgress from '@mui/material/LinearProgress';
import { addProjectCategory, getAllProjectCategories } from "../../../Services/Project/ProjectCategoryService";
import ProjectCategoryForm from "../../../Components/Forms/Pages/Project/ProjectCategory/ProjectCategoryForm";
import SnackbarContext from "../../../Context/SnackbarContext";

const formRules = {
    'name': {required: true}
}

const AddProjectCategory = (props) => {

    const {setDrawerTitle} = useContext(DrawerContext);
    const { showMessage } = useContext(SnackbarContext);
    const form = useForm();
    const {data, control, handleSubmit, getValues, setValue, formState: {errors}} = form;
    const [showLoader, setShowLoader] = useState(false);
    const [parents, setParents] = useState(0);

    useEffect(() => {
        setDrawerTitle(strings.pages.project.projectCategory.addProjectCategory.pageTitle);
    });

    useEffect(() => {
        fetch(); 
    },[])

    const fetch = () => {
        getAllProjectCategories().then(response => {
            if (!response || !response.ok) {
                return;
            }
            setParents(response.data);
        });
    }

    const onSubmit = (data) => {

        setShowLoader(true);

        addProjectCategory(data).then(response => {
            setShowLoader(false);

            if (!response || !response.ok) {
                showMessage(strings.commonMessages.errorAdding, 'error');
                props.onFinish();
                return;
            }

            showMessage(strings.commonMessages.addingSuccessful, 'success');
            props.onFinish();
        });
    }

    const onCancel = () => {
        props.onCancel();
    }

    return <div className='drawer-form'>
        <Paper className='paper'>
            {
                showLoader &&
                <LinearProgress/>
            }
            <ProjectCategoryForm
                formRules={formRules}
                values={getValues()}
                setValue={setValue}
                parents={parents}
                errors={errors} data={data} form={form} control={control}
                onSubmit={handleSubmit(onSubmit)} onCancel={() => onCancel()}/>
        </Paper>
    </div>
}

export default AddProjectCategory;